module.exports = __webpack_public_path__ + "static/media/nintendo_logo.66db2784.png";